import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-claim-dashboard',
  templateUrl: './claim-dashboard.component.html',
  styleUrls: ['./claim-dashboard.component.scss']
})
export class ClaimDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
